/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {InviteLinkUpdateModel} from "../../models/invite-link-update-model";
import {InviteLinkCreateModel} from "../../models/invite-link-create-model";
import {InviteLinkModel} from "../../models/invite-link-model";
import {AccountModel} from "../../models/account-model";
import {AccountCreateModel} from "../../models/account-create-model";


export interface AccountPostParams {
    body?: AccountCreateModel
}

export function accountsPost(http: HttpClient, rootUrl: string, params: AccountPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel>> {
    const rb = new RequestBuilder(rootUrl, accountsPost.PATH, 'post');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'application/json');

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<AccountModel>;
        })
    );
}

accountsPost.PATH = '/api/v1/accounts';
